const skills = [
    {
        id: 'frontend',
        title: 'Frontend',
        items: [
            { key: 'html5', name: 'HTML5' },
            { key: 'css3', name: 'CSS3' },
            { key: 'bootstrap', name: 'Bootstrap' },
            { key: 'mui', name: 'Material UI' },
            { key: 'tailwind', name: 'Tailwind CSS' },
            { key: 'javascript', name: 'Javascript' },
            { key: 'react', name: 'React JS' }
        ]
    },
    {
        id: 'backend',
        title: 'Backend',
        items: [
            { key: 'php', name: 'PHP' },
            { key: 'laravel', name: 'Laravel' },
            { key: 'nodejs', name: 'Node JS' },
            { key: 'github', name: 'GitHub' },
            { key: 'docker', name: 'Docker' },
        ]
    },
    {
        id: 'database',
        title: 'Database',
        items: [
            { key: 'sqlsrv', name: 'MS SQL' },
            { key: 'mysql', name: 'MySQL' },
            { key: 'pgsql', name: 'Postgres SQL' },
        ]
    }
];
const Skill = ({ skills }) => {
    return (
        <div className="skills-container">
            {
                skills.map((entry) => {
                    return (
                        <div className="skill-box" key={entry.key}>
                            <div className="skill-icon">
                                <img src={`img/web-dev/${entry.key}.png`} alt={entry.key} />
                            </div>
                            <div className="skill-name text-khi-50">{entry.name}</div>
                        </div>
                    )
                })
            }
        </div>
    )
}
function Skills() {
    return (
        <div className="skills-section">
            <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-2 lg:grid-cols-3">
                {
                    skills.map((entry) => {
                        return (
                            <div className="relative" key={entry.id}>
                                <div className="skill-card-animated animate-gradient--no-text-fill block animate-gradient overflow-hidden rounded-2.5xl !bg-clip-border p-[2px] text-center shadow-md transition-shadow hover:shadow-lg">
                                    <div className="skill-card rounded-2.5xl border border-khi-100 bg-white p-[1.1875rem] transition-shadow hover:shadow-lg dark:border-khi-700 dark:bg-khi-700">
                                        <div className="mb-3">
                                            <p className="text-md leading-normal text-khi-50">{entry.title}</p>
                                        </div>
                                        <Skill skills={entry.items} />
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default Skills